import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import Select from 'react-select';

import { doctorService } from '../../_services/doctor.service';

export default function ProfessionalOption({ defaultValue, handleSelected, placeholder = 'By Provider' }) {
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(defaultValue);

  useEffect(() => {
    setSelected(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    doctorService.getAll()
      .then((response) => {
        setOptions(response);
      });
  }, []);

  if (options.length === 0) {
    return <Spinner animation="border" role="status">
      <span className="sr-only">Loading...</span>
    </Spinner>
  }

  const professionalOption = options.map((option) => {
    const name = `${option.lastName}, ${option.firstName}`;

    return { value: option.id, label: name };
  });

  const selectedOption = professionalOption.find((professional) => {
    return professional.value === selected;
  });

  return <Select
    placeholder={placeholder}
    isClearable={true}
    options={professionalOption}
    onChange={selected => {
      if (selected) {
        setSelected(selected.value);
        handleSelected(selected.value, selected.label);
      } else {
        setSelected('');
        handleSelected('', '');
      }
    }}
    value={selectedOption || ''}
  />
}